


























































import {
  createComponent,
  inject,
  onMounted,
  computed,
  reactive,
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyKey from "@/components/company-key";
import FormHeader from '../../molecules/FormHeader.vue'
export default  createComponent({
  props: {
    data: {
      type: Object
    }
  } as const,
  setup(props) {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }
    const dialogInfor = computed(() => company.tableEvaluationList.dialog);
    const dialogEvaluation = computed(() => displayui.dialogEvaluationList);
    const closeDialog = () => {
      displayui.closeEvaluationListDialog()
    };
    return {
      dialogInfor,
      props, 
      closeDialog,
      dialogEvaluation
    };
  },
  components: {
    FormHeader
  }
})
